import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouseIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 22,
	viewBox: "0 0 25 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.03906 13.5234L8.30711 6.26562M8.30711 6.26562L15.5649 13.5234L24.3868 13.3906L19.2756 8.27942L8.30711 6.26562Z",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.17578 12.3984V20.9655",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4219 12.3984V20.9655",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.2734 13.4199V20.9647",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 20.9609H23.725",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3348 15.6797H6.69531V20.9651H10.3348V15.6797Z",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.57058 10.0076C2.54638 9.42489 1.07422 7.55404 1.07422 5.34582C1.07422 2.66733 3.24155 0.5 5.92004 0.5C8.59853 0.5 10.7659 2.66733 10.7659 5.34582C10.7659 5.80587 10.7045 6.25569 10.5818 6.68506",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1602 7.70644V4.57812H18.5728V8.14604",
			stroke: "#00666D",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgHouseIcon;
